'use strict';

function CnFileUploadController($q) {
  var vm = this;

  vm.$onInit = $onInit;


  vm.fileWasBrowsed = fileWasBrowsed;

  vm._onFormReset = _onFormReset;
  vm.onFormSubmit = onFormSubmit;
  vm.onFormCancel = onFormCancel;

  function $onInit() {
    vm.accept = vm.accept || 'text/plain';
    vm.onSubmit = vm.onSubmit() || $q.resolve;
    vm.onCancel = vm.onCancel() || $q.resolve;
    vm.file = {};
  }

  function _onFormReset() {
    vm.file = {};
    vm.form.$setPristine();
    vm.form.$setUntouched();
  }

  function onFormSubmit() {
    return vm.onSubmit(vm.file).finally(vm._onFormReset);
  }

  function fileWasBrowsed() {
    return vm.file.name && vm.file.name.length !== 0 || false;
  }

  function onFormCancel() {
    vm._onFormReset();
    vm.onCancel();
  }
}

module.exports = CnFileUploadController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-file-upload/cn-file-upload.controller.js
 ** module id = 92
 ** module chunks = 0
 **/